import React from "react";
import { poses } from "./AnimationTypes";

var Animation = function Animation(_ref) {
  var children = _ref.children,
      className = _ref.className,
      setPose = _ref.setPose,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "VISIBILITY" : _ref$type;
  var _poses$type = poses[type],
      initialState = _poses$type.initialState,
      endState = _poses$type.endState,
      MotionContainer = _poses$type.MotionContainer,
      variants = _poses$type.variants;
  var animate = setPose(initialState, endState);
  return /*#__PURE__*/React.createElement(MotionContainer, {
    className: className,
    initial: initialState,
    animate: animate,
    variants: variants
  }, children);
};

Animation.displayName = "Animation"; // eslint-disable-next-line

export default Animation;
export * from "./AnimationTypes";